/**
 * src/pages/ResetPassword.jsx
 * Elige una contraseña nueva con el token del correo (?token=..., válido 30 min).
 */
import { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import api from '../api/client'

export default function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [form, setForm] = useState({ password: '', confirm: '' })
  const [hecho, setHecho] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  function set(field) { return e => setForm(f => ({ ...f, [field]: e.target.value })) }

  async function handleSubmit(e) {
    e.preventDefault()
    if (form.password.length < 8) { setError('La contraseña debe tener al menos 8 caracteres'); return }
    if (form.password !== form.confirm) { setError('Las contraseñas no coinciden'); return }
    setLoading(true); setError('')
    try {
      await api.post('/auth/reset', { token, password: form.password })
      setHecho(true)
    } catch (err) {
      setError(err.response?.data?.detail || 'No se pudo cambiar la contraseña. Solicita un enlace nuevo.')
    } finally { setLoading(false) }
  }

  const inputStyle = {
    width: '100%', background: 'var(--color-surface-2)',
    border: '1px solid var(--color-border)', borderRadius: '8px',
    padding: '10px 14px', fontSize: '14px', fontFamily: 'var(--font-ui)',
    color: 'var(--color-text)', outline: 'none', boxSizing: 'border-box',
  }
  const labelStyle = { display: 'block', fontSize: '11px', fontWeight: 500, color: 'var(--color-text-2)', marginBottom: '5px', fontFamily: 'var(--font-mono)', letterSpacing: '0.05em' }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontWeight: 500, fontSize: '18px', color: 'var(--color-text)' }}>CM Monitor</div>
          <p style={{ fontSize: '12px', color: 'var(--color-text-3)', fontFamily: 'var(--font-mono)', letterSpacing: '0.08em', marginTop: '4px' }}>CONTRASEÑA NUEVA</p>
        </div>
        <div style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: '12px', padding: '28px', boxShadow: 'var(--shadow-lg)' }}>
          {hecho ? (
            <div>
              <p style={{ fontSize: '14px', color: 'var(--color-text)', lineHeight: 1.5 }}>
                ✓ Contraseña cambiada. Ya puedes iniciar sesión con la nueva.
              </p>
              <p style={{ textAlign: 'center', marginTop: '18px', fontSize: '13px' }}>
                <Link to="/acceder" style={{ color: 'var(--color-accent)', textDecoration: 'none' }}>Iniciar sesión</Link>
              </p>
            </div>
          ) : !token ? (
            <div>
              <p style={{ fontSize: '14px', color: 'var(--color-text)', lineHeight: 1.5 }}>
                Falta el código del enlace. Abre el enlace completo del correo o
                solicita uno nuevo.
              </p>
              <p style={{ textAlign: 'center', marginTop: '18px', fontSize: '13px' }}>
                <Link to="/forgot-password" style={{ color: 'var(--color-accent)', textDecoration: 'none' }}>Solicitar enlace nuevo</Link>
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={labelStyle}>CONTRASEÑA NUEVA</label>
                <input type="password" style={inputStyle} name="new-password" autoComplete="new-password"
                  value={form.password} onChange={set('password')} placeholder="Mínimo 8 caracteres" disabled={loading}
                  onFocus={e => e.target.style.borderColor = 'var(--color-accent)'}
                  onBlur={e => e.target.style.borderColor = 'var(--color-border)'} />
              </div>
              <div>
                <label style={labelStyle}>REPÍTELA</label>
                <input type="password" style={inputStyle} name="confirm-password" autoComplete="new-password"
                  value={form.confirm} onChange={set('confirm')} placeholder="La misma otra vez" disabled={loading}
                  onFocus={e => e.target.style.borderColor = 'var(--color-accent)'}
                  onBlur={e => e.target.style.borderColor = 'var(--color-border)'} />
              </div>
              {error && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '6px', padding: '10px 12px', fontSize: '12px', color: 'var(--color-error)', fontFamily: 'var(--font-mono)' }}>{error}</div>}
              <button type="submit" disabled={loading} style={{ width: '100%', background: loading ? 'var(--color-accent-dim)' : 'var(--color-accent)', color: loading ? 'var(--color-accent)' : '#fff', border: 'none', borderRadius: '8px', padding: '11px', fontSize: '14px', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'var(--font-ui)' }}>
                {loading ? 'Guardando…' : 'Guardar contraseña'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}
